import REF_CODE from "@workspace/casino_config/cookies/REF_CODE";
import { getCookie } from "@workspace/cookies/browser";
import sanitizeCookie from "./utils/sanitizeCookie";

const useRefCode = () => sanitizeCookie(getCookie(REF_CODE) as string);

export default useRefCode;
